module.exports = __webpack_public_path__ + "static/media/box_cad3.1162f70f.jpg";